export enum MicrositeRecipientDeactivationRequestStatus {
    Pending = 1,
    Denied = 2,
    Complete = 3
}